import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ParamSystemRawDefProvider, ParamSystemRawDefRecord, nullMenu } from '../hgm-setup/src/module/param/util/param-system-def';

@Injectable({ providedIn: 'root' })
export class BrowserNullParamDefProvider implements ParamSystemRawDefProvider {
    static nameValue = 'null';

    get record(): Observable<ParamSystemRawDefRecord | undefined> {
        return of({
            raw: {
                params: {},
                slots: {},
                slotLocalizations: [],
                // Provided specifically to satiate the DisplaySlotLocalizer during boot
                slotLocalizationSets: [{ name: 'default', codes: ['default'], map: {}, _type: 'slotLocalizationSet' }],
                menus: nullMenu,
            },
            metadata: {
                name: BrowserNullParamDefProvider.nameValue,
                description: BrowserNullParamDefProvider.nameValue,
                data: undefined,
                url: undefined,
            },
        });
    }

    onParsed() {}
}
